import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import Cookies from 'js-cookie'
import { handleAlert } from '../functions/handleAlert'

export const getUserData=createAsyncThunk("user/getUserData",async(args)=>{
  const token = Cookies.get(`${process.env.REACT_APP_TOKEN_NAME}`) 
  const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/users/${args.id}`,{
    headers:{
      Authorization:`Bearer ${token}`
    }
  })
  // console.log(res.data);
  return res.data
})

const initialState = {
  userData:null,
  isLoading:true
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
  },
  extraReducers:(builder)=>{
    builder.addCase(getUserData.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getUserData.fulfilled, (state, { payload }) => {
      state.userData = payload
      state.isLoading = false
    })
    builder.addCase(getUserData.rejected, (_, action) => {
      if (action.payload) {
        handleAlert(action.payload.errorMessage , "error") 
      } else {
        handleAlert(action.error.message, "error") 
      }
    })
  }
})


export default userSlice.reducer